// extracted by mini-css-extract-plugin
export default {"chartCard":"MonthlyEarnings_chartCard__hvbdh","chartTitle":"MonthlyEarnings_chartTitle__pZ+qL"};